"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNearestPickupPointsQuery = void 0;
var _fetching = require("@ori/fetching");
var _react = require("react");
var _constants = require("../constants");
var _swrConfig = require("../constants/swrConfig");
var _hooks = require("../hooks");
var _logger = require("../logger");
var _utils = require("../utils");
const fetchData = async options => {
  const promise = (0, _utils.getUrl)(options);
  promise.catch(error => {
    _logger.mainLogger.error(error, {
      action: 'useNearestPickupPointsQuery'
    });
  });
  return promise;
};
const useNearestPickupPointsQuery = (deliveryChannelId, setSelectedDeliveryChannelId, selectedDeliveryChannelId) => {
  const usedParams = {
    deliveryChannelId,
    top: _constants.NEAREST_PICKUP_POINTS_FIXED_SIZE
  };
  (0, _logger.logDebug)('useNearestPickupPointsQuery() hook called, params:', usedParams);
  const {
    cacheKeys,
    urlOptions
  } = (0, _hooks.useUrlOptions)('/system/ajax/DeliverySelection/GetNearestPickupPoints', usedParams);
  const handleNearestPickupPointsSuccess = (0, _react.useCallback)(nearestPickupPointsData => {
    if (nearestPickupPointsData?.pickup && selectedDeliveryChannelId === undefined) {
      setSelectedDeliveryChannelId(nearestPickupPointsData.pickup.deliveryChannelId);
    }
  }, [selectedDeliveryChannelId, setSelectedDeliveryChannelId]);
  const swrOptions = {
    ..._swrConfig.errorHandlingSwrOptions,
    onSuccess: nearestPickupPointsData => {
      (0, _logger.logDebug)('useNearestPickupPointsQuery() hook finished successfully');
      handleNearestPickupPointsSuccess(nearestPickupPointsData);
    }
  };
  const fetcher = async () => fetchData(urlOptions);
  const {
    data: nearestPickupPointsResult,
    error: nearestPickupPointsResultError,
    isValidating: isNearestPickupPointsResultLoading
  } = (0, _fetching.useSWR)(cacheKeys, fetcher, swrOptions);
  return {
    nearestPickupPointsResult,
    nearestPickupPointsResultError,
    isNearestPickupPointsResultLoading
  };
};
exports.useNearestPickupPointsQuery = useNearestPickupPointsQuery;